// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .qbiQsjBUScgM08jd1XtL .bJDyrlTIU9jMj652pL7W {
    display: table-cell;
    width: 100%;
    height: 100%;
    vertical-align: middle;
    text-align: center;
  }

  .qbiQsjBUScgM08jd1XtL label {
    display: inline-block;
    color: #9b9b9b;
    cursor: pointer;
    position: relative;
    font-weight: 400;
  }
  .qbiQsjBUScgM08jd1XtL label span {
    display: inline-block;
    position: relative;
    background-color: transparent;
    width: 25px;
    height: 25px;
    transform-origin: center;
    border: 2px solid #ff4444;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 10px;
    transition: background-color 100ms 200ms, transform 350ms cubic-bezier(0.78, -1.22, 0.17, 1.89);
  }
  .qbiQsjBUScgM08jd1XtL label span:before {
    content: "";
    width: 0px;
    height: 2px;
    border-radius: 2px;
    background: #ffffff;
    position: absolute;
    transform: rotate(45deg);
    top: 11px;
    left: 8px;
    transition: width 50ms ease 50ms;
    transform-origin: 0% 0%;
  }
  .qbiQsjBUScgM08jd1XtL label span:after {
    content: "";
    width: 0;
    height: 2px;
    border-radius: 2px;
    background: #ffffff;
    position: absolute;
    transform: rotate(305deg);
    top: 14px;
    left: 9px;
    transition: width 50ms ease;
    transform-origin: 0% 0%;
  }
  .qbiQsjBUScgM08jd1XtL label:hover span:before {
    width: 5px;
    transition: width 100ms ease;
  }
  .qbiQsjBUScgM08jd1XtL label:hover span:after {
    width: 10px;
    transition: width 150ms ease 100ms;
  }

  .qbiQsjBUScgM08jd1XtL input[type=checkbox] {
    display: none;
  }
  .qbiQsjBUScgM08jd1XtL input[type=checkbox]:checked + label span {
    background-color: #3c2020;
    transform: scale(1.25);
  }
  .qbiQsjBUScgM08jd1XtL input[type=checkbox]:checked + label span:after {
    width: 10px;
    background: #fff;
    transition: width 150ms ease 100ms;
  }
  .qbiQsjBUScgM08jd1XtL input[type=checkbox]:checked + label span:before {
    width: 5px;
    background: #fff;
    transition: width 150ms ease 100ms;
  }
  .qbiQsjBUScgM08jd1XtL input[type=checkbox]:checked + label:hover span {
    background-color: #d90505;
    transform: scale(1.25);
  }
  .qbiQsjBUScgM08jd1XtL input[type=checkbox]:checked + label:hover span:after {
    width: 10px;
    background: #fff;
    transition: width 150ms ease 100ms;
  }
  .qbiQsjBUScgM08jd1XtL input[type=checkbox]:checked + label:hover span:before {
    width: 5px;
    background: #fff;
    transition: width 150ms ease 100ms;
  }
`, "",{"version":3,"sources":["webpack://./src/js/VaccineStock/InstitutionalSection/SwitchStockComponent/styles.module.css"],"names":[],"mappings":";EACE;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,+FAA+F;EACjG;EACA;IACE,WAAW;IACX,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,SAAS;IACT,gCAAgC;IAChC,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,kCAAkC;EACpC;;EAEA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,kCAAkC;EACpC;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,kCAAkC;EACpC","sourcesContent":["\n  .checkbox-wrapper-24 .checkbox {\n    display: table-cell;\n    width: 100%;\n    height: 100%;\n    vertical-align: middle;\n    text-align: center;\n  }\n\n  .checkbox-wrapper-24 label {\n    display: inline-block;\n    color: #9b9b9b;\n    cursor: pointer;\n    position: relative;\n    font-weight: 400;\n  }\n  .checkbox-wrapper-24 label span {\n    display: inline-block;\n    position: relative;\n    background-color: transparent;\n    width: 25px;\n    height: 25px;\n    transform-origin: center;\n    border: 2px solid #ff4444;\n    border-radius: 50%;\n    vertical-align: middle;\n    margin-right: 10px;\n    transition: background-color 100ms 200ms, transform 350ms cubic-bezier(0.78, -1.22, 0.17, 1.89);\n  }\n  .checkbox-wrapper-24 label span:before {\n    content: \"\";\n    width: 0px;\n    height: 2px;\n    border-radius: 2px;\n    background: #ffffff;\n    position: absolute;\n    transform: rotate(45deg);\n    top: 11px;\n    left: 8px;\n    transition: width 50ms ease 50ms;\n    transform-origin: 0% 0%;\n  }\n  .checkbox-wrapper-24 label span:after {\n    content: \"\";\n    width: 0;\n    height: 2px;\n    border-radius: 2px;\n    background: #ffffff;\n    position: absolute;\n    transform: rotate(305deg);\n    top: 14px;\n    left: 9px;\n    transition: width 50ms ease;\n    transform-origin: 0% 0%;\n  }\n  .checkbox-wrapper-24 label:hover span:before {\n    width: 5px;\n    transition: width 100ms ease;\n  }\n  .checkbox-wrapper-24 label:hover span:after {\n    width: 10px;\n    transition: width 150ms ease 100ms;\n  }\n\n  .checkbox-wrapper-24 input[type=checkbox] {\n    display: none;\n  }\n  .checkbox-wrapper-24 input[type=checkbox]:checked + label span {\n    background-color: #3c2020;\n    transform: scale(1.25);\n  }\n  .checkbox-wrapper-24 input[type=checkbox]:checked + label span:after {\n    width: 10px;\n    background: #fff;\n    transition: width 150ms ease 100ms;\n  }\n  .checkbox-wrapper-24 input[type=checkbox]:checked + label span:before {\n    width: 5px;\n    background: #fff;\n    transition: width 150ms ease 100ms;\n  }\n  .checkbox-wrapper-24 input[type=checkbox]:checked + label:hover span {\n    background-color: #d90505;\n    transform: scale(1.25);\n  }\n  .checkbox-wrapper-24 input[type=checkbox]:checked + label:hover span:after {\n    width: 10px;\n    background: #fff;\n    transition: width 150ms ease 100ms;\n  }\n  .checkbox-wrapper-24 input[type=checkbox]:checked + label:hover span:before {\n    width: 5px;\n    background: #fff;\n    transition: width 150ms ease 100ms;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox-wrapper-24": `qbiQsjBUScgM08jd1XtL`,
	"checkbox": `bJDyrlTIU9jMj652pL7W`
};
export default ___CSS_LOADER_EXPORT___;
